import Icon1 from "../icons/Icon";

const ListCellOrg = ({ org, removable, onDelete, icon_name = "expert" }) => {
  return (
    <div className="flex flex-row w-full justify-between items-center p-2 rounded-md overflow-auto shadow-md">
      {/* User Avatar and Email */}
      <div className="flex flex-row gap-2">
        <img
          src={org.logo || "https://i.ibb.co/xqZTQvtX/image.png"}
          alt="photo"
          className="h-10 w-10 rounded-full object-contain"
        />{" "}
        <div className="flex flex-col justify-center items-start rounded-full w-full">
          <div className="text-h3">{org.name}</div>{" "}
          <div className="text-h5 text-nowrap text-clip max-w-full overflow-hidden text-shadow_50">
            {org.email}
          </div>
        </div>
      </div>

      {/* Close Icon (Removable functionality) */}
      {removable && (
        <div
          className="flex flex-col cursor-pointer "
          onClick={() => onDelete(org)}
        >
          <Icon1
            icon_name="delete"
            height="16px"
            width="16px"
            hover_color={"red"}
            fill={"grey"}
          />
        </div>
      )}
    </div>
  );
};

export default ListCellOrg;
